module.exports = __webpack_public_path__ + "static/media/post2.ed2a6ff2.jpg";